<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()" autocomplete="off">

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'intelligence-reporting.forms.level' |translate}}</mat-label>
      <mat-select [formControl]="formTypeControl">
        <mat-option value="">-</mat-option>
        <mat-option [value]="'Country'">Country</mat-option>
        <mat-option [value]="'System'">System</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.countries.name' |translate}}</mat-label>
      <input matInput type="text" [formControl]="nameControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'filter.start' | translate}} {{'kf-reporting.year' |translate}}</mat-label>
      <input matInput type="number" [formControl]="startYearControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'filter.end' | translate}} {{'kf-reporting.year' |translate}}</mat-label>
      <input matInput type="number" [formControl]="endYearControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'intelligence-data-entry.form' |translate}}</mat-label>
      <input matInput type="text" [formControl]="formControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label> {{'kf-reporting.launched' |translate}} range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [formControl]="startLaunchedControl">
        <input matEndDate [formControl]="endLaunchedControl">
      </mat-date-range-input>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker ></mat-date-range-picker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'intelligence-data-entry.min' |translate}} {{'intelligence-reporting.questions.questions' |translate}}</mat-label>
      <input matInput type="number" [formControl]="minQuestionsControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'intelligence-data-entry.max' |translate}} {{'intelligence-reporting.questions.questions' |translate}}</mat-label>
      <input matInput type="number" [formControl]="maxQuestionsControl" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-item">
      <mat-label>{{'admin.countries.status' |translate}}</mat-label>
      <mat-select [formControl]="statusControl">
        <mat-option value="">-</mat-option>
        <mat-option [value]="'NOT STARTED'">Not Started</mat-option>
        <mat-option [value]="'INCOMPLETE'">Incomplete</mat-option>
        <mat-option [value]="'COMPLETED'">Completed</mat-option>
      </mat-select>
    </mat-form-field>

    <button type="reset" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>
  </form>
</div>

